const fileTypes = {
	UPLOAD: {
		REQUEST: 'FILE_UPLOAD_REQUEST',
		SUCCESS: 'FILE_UPLOAD_SUCCESS',
		FAILURE: 'FILE_UPLOAD_FAILURE',
		CLEAR: 'FILE_UPLOAD_CLEAR',
	},

	DELETE: {
		REQUEST: 'FILE_DELETE_REQUEST',
		SUCCESS: 'FILE_DELETE_SUCCESS',
		FAILURE: 'FILE_DELETE_FAILURE',
		CLEAR: 'FILE_DELETE_CLEAR',
	},

	READ_FROM_PATH: {
		REQUEST: 'FILE_READ_FROM_PATH_REQUEST',
		SUCCESS: 'FILE_READ_FROM_PATH_SUCCESS',
		FAILURE: 'FILE_READ_FROM_PATH_FAILURE',
		CLEAR: 'FILE_READ_FROM_PATH_CLEAR',
	},
};

export default fileTypes;
